/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        data-name="Layer 1"
        viewBox="0 0 69.92 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M34.93 0A34.93 34.93 0 0 0 0 34.93a42.8 42.8 0 0 0 2.15 12.75c2.75 8.83 8 18.21 15 27.74a172.68 172.68 0 0 0 11.66 14.24l.92 1 .44.48.87.92.83.87.79.82.47.48 1 1a1.25 1.25 0 0 0 1.74 0l.39-.38.62-.62.85-.88.8-.85.84-.89.89-1 .91-1A176.86 176.86 0 0 0 52.8 75.34c7-9.53 12.21-18.91 15-27.74a43.12 43.12 0 0 0 2.12-12.75 34.94 34.94 0 0 0-35-34.88Zm0 2.5a32.43 32.43 0 0 1 32.43 32.43 40.4 40.4 0 0 1-2 12c-2.65 8.52-7.75 17.67-14.59 27a171.26 171.26 0 0 1-11.49 14l-.9 1c-.15.16-.29.32-.44.47l-.85.91-.82.86-.78.81-.55.56-.55-.56-.78-.81-.82-.86-.85-.91-.88-1-.46-.5a169.22 169.22 0 0 1-11.49-14c-6.85-9.29-12-18.4-14.61-27a40.4 40.4 0 0 1-2-12A32.43 32.43 0 0 1 34.92 2.46Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M34.93 15.82a18.62 18.62 0 1 0 18.62 18.62 18.61 18.61 0 0 0-18.61-18.61Zm0 2.5a16.12 16.12 0 1 1-16.11 16.13 16.12 16.12 0 0 1 16.11-16.11Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'MapPinIcon';

export default Icon;
